import {
    POST_TEMPORAL_DP_LOADING,
    POST_TEMPORAL_DP_SUCCESS,
    POST_TEMPORAL_DP_REJECT,
} from '../../actions/addTemporalDP/actions';

// Estado inicial
const initialState = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
};

// Reducer
const addTemporalDPReducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_TEMPORAL_DP_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case POST_TEMPORAL_DP_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            data: [...action.payload,]
        };

        case POST_TEMPORAL_DP_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload
        };

        default: return state;
    }
};

export default addTemporalDPReducer;
